import { AxiosResponse } from 'axios';

import API from '../Api';
import { PriceFixOfferUI, BasicFeeAndMarginToday, PriceFixUI, Contract } from '../types/contract';
import { getUserToken, logUserOut } from '../utils/login';

export const fetchPriceFixOffers = async (): Promise<PriceFixOfferUI[]> => {
  const priceFixRequest: AxiosResponse<PriceFixOfferUI[]> = await API({
    method: 'get',
    url: `/v1/priceFixOffers`,
    data: {
      content: '',
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return priceFixRequest.data;
};
export const fetchPriceFixes = async (dataOwnerCustomerId: number, actingCustomerId: number, contractCode: string): Promise<PriceFixUI[]> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  if (bearer) {
    const priceFixRequest: AxiosResponse<PriceFixUI[]> = await API({
      method: 'get',
      url: `/v2/priceFixes/${dataOwnerCustomerId}/${actingCustomerId}/${contractCode}`,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          logUserOut();
        }
        return error.response;
      }
    });

    return priceFixRequest.data;
  }
  return [];
};

export const fetchBasicFeeAndMarginToday = async (): Promise<BasicFeeAndMarginToday[]> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  if (bearer) {
    const priceFixingFeesRequest: AxiosResponse<BasicFeeAndMarginToday[]> = await API({
      method: 'get',
      url: `/v1/priceFixingFees`,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
      data: {
        content: '',
      },
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          logUserOut();
        }
        return error.response;
      }
    });

    return priceFixingFeesRequest.data;
  }
  return [];
};

export const postNewPriceFix = async (
  dataOwnerCustomerId: number,
  actingCustomerId: number,
  offer: PriceFixOfferUI,
  contract: Contract,
  meteringPointId: string,
  percentage: number,
): Promise<number> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  if (bearer) {
    const newPriceFixRequest: AxiosResponse<number> = await API({
      method: 'post',
      url: `/v2/priceFixes/${dataOwnerCustomerId}/${actingCustomerId}/${contract.contractCode}`,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
      data: {
        priceId: offer.Price_id,
        contractNo: contract.contractNo,
        contractCode: contract.contractCode,
        meteringPointId: meteringPointId,
        fixingPercent: percentage,
      },
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          logUserOut();
        }
        return error.response;
      }
    });

    return newPriceFixRequest.status;
  }
  return 500;
};
